import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { HashRouter as Switch, Route, Routes, Navigate } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";

import Login from "./screens/user_login_auth/login";
import SignUp from "./screens/user_login_auth/signUp";
import Logout from "./screens/user_login_auth/logout";
import ChangePassword from "./screens/user_login_auth/changePassword";
import Payment from "./screens/payment/payment";
import Dashboard from "./screens/dashboard/dashboard";
import NormalView from "./screens/normalView/normalView";
import CalenderView from "./screens/calenderView/calenderView";
import Holidays from "./screens/master/holiday/holidays";
import HolidaysAdd from "./screens/master/holiday/holidayAdd";
import Event from "./screens/master/Events/event";
import EventAdd from "./screens/master/Events/eventAdd";
import BookingDetails from "./screens/booking_details/bookingDetails";
import CompanyInfo from "./screens/booking_details/companyinfo";
import AdditionalServices from "./screens/booking_details/aditionalServices";
import TermsAndConditions from "./screens/booking_details/termsAndConditions";
import Summary from "./screens/booking_details/summary";
import Cart from "./screens/booking_details/cart";
import Services from "./screens/master/additionalService/additionalService";
import ServicesAdd from "./screens/master/additionalService/additionalServiceAdd";
import Client from "./screens/master/client/client";
import OrderConfirmed from "./screens/booking_details/orderConfirmed";
import ClientAdd from "./screens/master/client/clientAdd";
import MultiPurposeCentre from "./screens/master/multiPurposeCentre/multiPurposeCentre";
import MultiPurposeCentreAdd from "./screens/master/multiPurposeCentre/multiPurposeCentreAdd";
import User from "./screens/security/user/user_list";
import UserAU from "./screens/security/user/user_au";
import AccountReceiptsList from './screens/Accounts/account_reciepts/account_receipts_list'
import AccountReceiptsAU from './screens/Accounts/account_reciepts/account_receipts_au'
import AccountCreditNoteList from './screens/Accounts/account_credit_note/account_credit_note_list'
import AccountCreditNoteAU from './screens/Accounts/account_credit_note/account_credit_note_au'
import AccountDebitNoteList from './screens/Accounts/account_debit_note/account_debit_note_list'
import AccountDebitNoteAU from './screens/Accounts/account_debit_note/account_debit_note_au'
import MyOrders from "./screens/my_orders/myOrders";
import Roles from "./screens/security/roles/roles";
import RolesAdd from "./screens/security/roles/rolesAdd";
import Orders from "./screens/Accounts/orders/orders";
import MyOrdersEdit from "./screens/my_orders/myOrdersEdit";
import OrdersEdit from "./screens/Accounts/orders/ordersEdit";
import Due_payments_list from "./screens/Accounts/account_due_payments/due_payments_list";
import CheckList from "./screens/checkList/checkList";
import CheckList_au from "./screens/checkList/checkList_au";
import FeedbackForm from "./screens/feedback/feedback";
import ReportList from "./screens/reports/reportList";
import OrderReport from "./screens/reports/operations_report/order_report";
import FeedbackReport from "./screens/reports/other_report/feedback_report";
import PendingSecurityDepositReport from "./screens/reports/finance_report/pending_security_deposit_report";
import ReceiptReport from "./screens/reports/finance_report/receipt_report";
import InvoiceReport from "./screens/reports/finance_report/invoice_report";
import Profile from "./screens/user_login_auth/profile";
import VendorList from "./screens/master/vendor/vendorList";
import VendorAu from "./screens/master/vendor/vendorAu";
import ThirdPartyOrderList from "./screens/Accounts/account_third_party_order/account_third_party_order_list";
import ThirdPartyOrderAU from "./screens/Accounts/account_third_party_order/account_third_party_order_au";
import TimeSlotList from "./screens/master/timeSlot/timeSlotList";
import SeatingTypeList from "./screens/master/seatingType/seatingTypeList";
import TimeSlotAU from "./screens/master/timeSlot/timeSlotAU";
import SeatingTypeAU from "./screens/master/seatingType/seatingTypeAU";
import PageNotFound from "./screens/user_login_auth/pageNotFound";
import InvoicesList from "./screens/Accounts/account_invoices/account_invoices_list";
import ViewSpecifications from "./screens/preBooking/viewSpecifications";
import BookNow from "./screens/preBooking/bookNow";
import PreLogin from "./screens/preBooking/loginSignUp";
import Guidelines from "./screens/preBooking/guidelines";
import UnblockedCalenderList from "./screens/Accounts/unblock_calender/unblock_calender";


function App() {
  // useEffect(() => {
  //   sessionStorage.setItem("renderPage", 'countrySelect')

  // }, [])

  return (
    <div className="App">
      <div className="auth-inner">
        <Switch>
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/login/:status" element={<Login />} />
            <Route exact path="/checkList" element={<CheckList />} />
            <Route exact path="/" element={<NormalView />} />
            <Route exact path="/checkList_au" element={<CheckList_au />} />
            <Route exact path="/signUp" element={<SignUp />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />
            <Route exact path="/logout" element={<Logout />} />
            <Route exact path="/payment" element={<Payment />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/normalView/:id" element={<NormalView />} />
            <Route exact path="/normalView" element={<NormalView />} />
            <Route exact path="/calenderView" element={<CalenderView />} />
            <Route exact path="/calenderView/:id" element={<CalenderView />} />
            <Route exact path="/BookingDetails" element={<BookingDetails />} />
            <Route exact path="/companyInfo" element={<CompanyInfo />} />
            <Route exact path="/additionalServices" element={<AdditionalServices />} />
            <Route exact path="/termsAndConditons" element={<TermsAndConditions />} />
            <Route exact path="/summary" element={<Summary />} />
            <Route exact path="/orderConfirmed/:id" element={<OrderConfirmed />} />
            {/* <Route exact path="/cart" element={<Cart />} />
            <Route exact path="/cart/:status" element={<Cart />} /> */}
            {/* master Pages */}
            <Route exact path="/holidays" element={<Holidays />} />
            <Route exact path="/holidays_edit" element={<HolidaysAdd />} />
            <Route exact path="/events" element={<Event />} />
            <Route exact path="/events_add" element={<EventAdd />} />
            <Route exact path="/additional_service" element={<Services />} />
            <Route exact path="/additional_services_add" element={<ServicesAdd />} />
            <Route exact path="/client" element={<Client />} />
            <Route exact path="/client_add" element={<ClientAdd />} />
            <Route exact path="/multi_purpose_centre" element={<MultiPurposeCentre />} />
            <Route exact path="/multi_purpose_centre_add" element={<MultiPurposeCentreAdd />} />
            <Route exact path="/vendor" element={<VendorList />} />
            <Route exact path="/vendorAU" element={<VendorAu />} />
            <Route exact path="/timeSlot" element={<TimeSlotList />} />
            <Route exact path="/timeSlotAU" element={<TimeSlotAU />} />
            <Route exact path="/seatingType" element={<SeatingTypeList />} />
            <Route exact path="/seatingTypeAU" element={<SeatingTypeAU />} />

            <Route exact path="/my_orders" element={<MyOrders />} />
            <Route exact path="/my_orders/:status" element={<MyOrders />} />
            <Route exact path="/my_orders_edit" element={<MyOrdersEdit />} />
            <Route exact path="/orders" element={<Orders />} />
            <Route exact path="/ordersEdit" element={<OrdersEdit />} />
            <Route exact path="/role" element={<Roles />} />
            <Route exact path="/role_add" element={<RolesAdd />} />
            <Route exact path="/user" element={<User />} />
            <Route exact path="/userAU" element={<UserAU />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/accountReceiptsList" element={<AccountReceiptsList />} />
            <Route exact path="/accountReceiptsAU" element={<AccountReceiptsAU />} />
            <Route exact path="/creditNoteList" element={<AccountCreditNoteList />} />
            <Route exact path="/creditNoteAU" element={<AccountCreditNoteAU />} />
            <Route exact path="/debitNoteList" element={<AccountDebitNoteList />} />
            <Route exact path="/debitNoteAU" element={<AccountDebitNoteAU />} />
            <Route exact path="/duePaymentsList" element={<Due_payments_list />} />
            <Route exact path="/invoicesList" element={<InvoicesList />}/>
            <Route exact path="/unblockedCalender" element={<UnblockedCalenderList />}/>
          
            {/* Feedback */}
            <Route exact path="/feedback/:id" element={<FeedbackForm />} />
            <Route exact path="/feedback" element={<FeedbackForm />} />

            <Route exact path="/reportList" element={<ReportList />} />
            <Route exact path="/orderReport" element={<OrderReport />} />
            <Route exact path="/feedbackReport" element={<FeedbackReport />} />
            <Route exact path="/pendingSecurityDepositReport" element={<PendingSecurityDepositReport />} />
            <Route exact path="/receiptReport" element={<ReceiptReport />} />
            <Route exact path="/invoiceReport" element={<InvoiceReport />} />
            {/* <Route exact path="/thirdPartyOrder" element={<ThirdPartyOrder />} /> */}
            <Route exact path="/thirdPartyOrderAU" element={<ThirdPartyOrderAU />} />
            <Route exact path="/thirdPartyOrderList" element={<ThirdPartyOrderList />} />
            <Route exact path="/bookNow" element={<BookNow />} />
            <Route exact path="/preLogin" element={<PreLogin />} />
            <Route exact path="/viewSpecifications" element={<ViewSpecifications />} />
            <Route exact path="/guidelines" element={<Guidelines />} />
            <Route exact path="/notFound" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/notFound" />} />
          </Routes>
        </Switch>
      </div>
    </div>
  );
}

export default App;
